import { useSyncExternalStore } from "react";

const KEY = "urwan_pocket";

function load() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
        return Array.isArray(raw) ? raw.filter((p) => p && p.key && p.productId) : [];
    } catch {
        return [];
    }
}

let items = load();
let open = false;
let bump = 0;
let snap = computeSnap();
const listeners = new Set();

function computeSnap() {
    return {
        items,
        open,
        bump,
        count: items.reduce((n, p) => n + p.qty, 0),
        subtotal: items.reduce((n, p) => n + p.qty * p.price, 0),
    };
}

function save() {
    try {
        localStorage.setItem(KEY, JSON.stringify(items));
    } catch {}
}

function rebuild() {
    snap = computeSnap();
    save();
    listeners.forEach((l) => l());
}

export function cartAdd(item) {
    const key = `${item.productId}-${item.size}`;
    const found = items.find((p) => p.key === key);
    items = found
        ? items.map((p) => (p.key === key ? { ...p, qty: p.qty + 1 } : p))
        : [...items, { ...item, key, qty: 1 }];
    bump += 1;
    rebuild();
}

export function cartRemove(key) {
    items = items.filter((p) => p.key !== key);
    rebuild();
}

export function cartSetOpen(v) {
    open = v;
    rebuild();
}

export function cartClear() {
    items = [];
    rebuild();
}

function subscribe(l) {
    listeners.add(l);
    return () => listeners.delete(l);
}

export function useCart() {
    const state = useSyncExternalStore(subscribe, () => snap);
    return { ...state, add: cartAdd, remove: cartRemove, setOpen: cartSetOpen, clear: cartClear };
}
